module.exports = {
	"classes": [
		"dashboard-page",
		"header-dark"
	],
	"title": "User Management",
	"metas": {
		"description": "Auth0 provides the simplest and easiest to use User interface tools to help administrators manage user identities including password resets, creating and provisioning, blocking and deleting users."
	},
	"opengraph": {
		"og:title": "User Management",
		"og:description": "Auth0 provides the simplest and easiest to use User interface tools to help administrators manage user identities including password resets, creating and provisioning, blocking and deleting users.",
		"og:url": "https://auth0.com/user-management"
	},
	"twittercard": {
		"twitter:title": "User Management",
		"twitter:description": "Auth0 provides the simplest and easiest to use User interface tools to help administrators manage user identities including password resets, creating and provisioning, blocking and deleting users."
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/dashboard/metadata.json
// module id = 1378
// module chunks = 0